module.exports = __webpack_public_path__ + "static/media/home-header-bg.afa4743f.png";